<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Voting Results</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="toggleSearch()">
        <mat-icon>search</mat-icon>
        @if (isSearchVisible) { Close search } @else { Search @if (getAppliedFiltersCount() > 0) { ({{ getAppliedFiltersCount() }}) } }
      </button>
      <button mat-raised-button color="primary" (click)="onExportToCsv()">
        <mat-icon>insert_chart_outlined</mat-icon>
        CSV Export
      </button>
    </div>
  </div>
  <app-company-vote-result-search-box
    [isSearchVisible]="isSearchVisible"
    [initialFilter]="currentSearchFilter"
    (searchFilter)="onSearchFilter($event)">
  </app-company-vote-result-search-box>
  <app-generic-list
    [items]="voteResults"
    [columnDefinitions]="columnDefinitions"
    [pageSize]="pageSize"
    [currentPage]="currentPage - 1"
    [pageSizeOptions]="[5, 10, 25, 50]"
    [totalItems]="totalItems"
    [serverSidePagination]="true"
    [enableEdit]="false"
    [enableDelete]="true"
    [enableLink]="true"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
    (linkClick)="onLinkToCompany($event)"
    (deleteClick)="onDeleteVoteResult($event)">
  </app-generic-list>
</div>
